@if (!loading()) {
  <h1 mat-dialog-title>Contactgegevens aanpassen</h1>
  <div mat-dialog-content>
    <form (ngSubmit)="save()" [formGroup]="userForm">
      <h4 class="contact-info-title">Persoonlijke gegevens</h4>
      <mat-form-field>
        <mat-label>E-mailadres</mat-label>
        <input formControlName="email" type="email" autocomplete="email" matInput />
        @if (userForm.controls.email.hasError('emailValidator')) {
          <mat-error>E-mailadres is ongeldig.</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Mobiel telefoonnummer</mat-label>
        <input formControlName="phoneNumber" type="tel-national" autocomplete="tel-national" matInput />
        @if (userForm.controls.phoneNumber.hasError('phoneValidator')) {
          <mat-error>Mobiel telefoonnummer is ongeldig.</mat-error>
        }
      </mat-form-field>
      <h4 class="contact-info-title">Noodnummers</h4>
      <div class="emergency-phone-number-wrapper">
        @for (phoneNumber of emergencyPhoneNumbers(); track phoneNumber.phoneNumber; let i = $index) {
          <div class="emergency-phone-number-edit-wrapper">
            @if (!phoneNumber.editing) {
              <div class="phone-number-info-wrapper">
                <div class="phone-number-info">
                  <div class="phone-number-info-name">{{ phoneNumber.name }}</div>
                  <a [href]="'tel:' + phoneNumber.phoneNumber" class="phone-number-info-number">
                    {{ phoneNumber.phoneNumber }}
                  </a>
                  <div class="phone-number-info-description">
                    {{ phoneNumber.description }}
                  </div>
                </div>
                <div class="phone-number-buttons">
                  <button
                    type="button"
                    mat-icon-button
                    aria-label="Telefoonnummer bewerken"
                    (click)="managePhoneNumber('edit', i)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    type="button"
                    mat-icon-button
                    aria-label="Telefoonnummer verwijderen"
                    (click)="managePhoneNumber('delete', i)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            }
            @if (phoneNumber.editing) {
              <form autocomplete="off" [formGroup]="phoneForm" class="phone-form">
                <mat-form-field hideRequiredMarker>
                  <mat-label>Naam</mat-label>
                  <input formControlName="name" autocomplete="name" matInput />
                  @if (phoneForm.controls.name.hasError('required')) {
                    <mat-error>Dit veld is verplicht.</mat-error>
                  }
                </mat-form-field>
                <mat-form-field hideRequiredMarker>
                  <mat-label>Telefoonnummer</mat-label>
                  <input formControlName="phoneNumber" matInput />
                  @if (phoneForm.controls.phoneNumber.hasError('required')) {
                    <mat-error>Dit veld is verplicht.</mat-error>
                  }
                  @if (phoneForm.controls.phoneNumber.hasError('phoneValidator')) {
                    <mat-error>Telefoonnummer is ongeldig.</mat-error>
                  }
                </mat-form-field>
                <mat-form-field hideRequiredMarker>
                  <mat-label>Relatie</mat-label>
                  <input formControlName="description" matInput />
                  @if (phoneForm.controls.description.hasError('required')) {
                    <mat-error>Dit veld is verplicht.</mat-error>
                  }
                </mat-form-field>
                <div class="save-button-wrapper">
                  <button
                    mat-flat-button
                    class="save-phone-number-button secondary-color"
                    [disabled]="!phoneForm.valid"
                    (click)="savePhoneNumber('edit', i)"
                  >
                    Noodnummer opslaan
                  </button>
                </div>
              </form>
            }
          </div>
        }
        @if (!addingPhoneNumber()) {
          <button
            mat-flat-button
            type="button"
            class="add-phone-number-button secondary-color"
            (click)="managePhoneNumber('add')"
          >
            <mat-icon>add</mat-icon> Noodnummer toevoegen
          </button>
        }
        @if (addingPhoneNumber()) {
          <form autocomplete="off" [formGroup]="phoneForm" class="phone-form">
            <mat-form-field hideRequiredMarker>
              <mat-label>Naam</mat-label>
              <input formControlName="name" autocomplete="name" matInput />
              @if (phoneForm.controls.name.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field hideRequiredMarker>
              <mat-label>Telefoonnummer</mat-label>
              <input formControlName="phoneNumber" matInput />
              @if (phoneForm.controls.phoneNumber.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
              @if (phoneForm.controls.phoneNumber.hasError('phoneValidator')) {
                <mat-error>Telefoonnummer is ongeldig.</mat-error>
              }
            </mat-form-field>
            <mat-form-field hideRequiredMarker>
              <mat-label>Relatie</mat-label>
              <input formControlName="description" matInput />
              @if (phoneForm.controls.description.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <div class="save-button-wrapper">
              <button
                mat-flat-button
                type="button"
                class="save-phone-number-button secondary-color"
                [disabled]="!phoneForm.valid"
                (click)="savePhoneNumber('add')"
              >
                Noodnummer opslaan
              </button>
            </div>
          </form>
        }
      </div>
    </form>
  </div>
}
@if (!loading()) {
  <div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]>Annuleren</button>
    <button
      mat-flat-button
      (click)="save()"
      [disabled]="awaitingResponse() || !userForm.valid"
      [class.spinner]="awaitingResponse()"
    >
      Opslaan
    </button>
  </div>
}
